<template>
  <div>
    <acheader></acheader>
    <div class="row mainbody">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <clientsidebar></clientsidebar>
      </div>
      <div class="col-lg-10 col-md-8 col-sm-12">
        <div class="moduleWrapper">
          <div v-if="mess!==null" class="moduleCard">

            <div class='row'>
              <div class='col-8'>
                <b>Subject: </b>{{mess.Subject}}<br />
                <b>Sent: </b>{{mess.MessageDate}}
              </div>
              <div class='col-3 text-right'>
                <button class="btn btn-secondary btn-medium" @click="doInbox" id="return_to_inbox">Return to Inbox</button>
              </div>
            </div>
       
            <div class='row mt-2' v-if="hasReply===true">
              <div class='col-12'>
                <b>From: </b>{{mess.FromName}} <a href='javascript:void(0)' @click="doReply(mess.FromID)">Reply</a>
              </div>
            </div>
            <div class='row mt-2' v-if="hasReply!==true&&toAddresses.length>0">
              <div class='col-12'>
                <b>To: </b><span>{{toAddresses}}</span>
              </div>
            </div>
    
            <div class="row mt-2" v-if="mess.Attachment!==null&&mess.Attachment.length>0">
              <div class="col-12">
                <b>Attachment:</b> <a href='javascript:void(0)' @click="doDownload(mess.AttachURL,mess.Attachment)">{{mess.Attachment}}</a>
              </div>
            </div>
            <div class='row mt-2'>
              <div class='col-11' style='border:1px solid #777;padding:2%;margin:1%;min-height:400px;' v-html="mess.Message"></div>
            </div>
          </div>
          </div>
        </div>
      <div class="clearfix"></div></div><acfooter></acfooter>
   
  </div>
</template>

<script>
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import clientsidebar from "../../layout/Client/Sidebar.vue"

  export default {
    name: 'CliInbox',
    components:{acheader,acfooter,clientsidebar},
    data() {
      return {
         hasReply:false,
         mess:null,
         toAddresses:"",
         toList:[]
      }
    },
    methods: {
      doDownload(url,name) {
        var req = new XMLHttpRequest();
        req.open("GET", url);
        req.responseType = "blob";     
        req.onload = function (event) {
          var blob = req.response;
          var link = document.createElement('a');     
          link.href = window.URL.createObjectURL(blob);
          link.download = name;
          document.body.appendChild(link);
          link.click();
          link.remove();
        };
        req.send();
      },
      doInbox() {
         this.$router.push("/client/"+this.udata.ClientID+"/inbox")
      },
      doReply(frid) {
         this.$router.push("/client/newmessage/"+frid);
      }
    },
    mounted() {
      this.doPage().then(r=>{
   
         this.apiCommand([{
             Operation: "Client",
             Function: "GetMessage",
             Fields: {
               ClientMessageID: this.$route.params.id
             }
         }]).then(response=> {

           var cr = JSON.parse(response.CommandResult);
           var tmess = JSON.parse(cr.returnObjects[0].returnObject);

           this.bootstrapClient(this.udata.ClientID);

           if (tmess.FromID!==this.udata.ClientID) {
             this.hasReply=true;
           }
           tmess.MessageDate=this.buildDateTime(tmess.MessageDate, true);
           if (tmess.AttachmentID!==null && tmess.AttachmentID!==this.emptyguid) {
             tmess.AttachURL= "https://attachments.simmersion.com/"+tmess.AttachmentID
           }

           if (!this.hasReply) {
             this.apiCommand([{
               Operation: "Client",
               Function: "GetMessageClients",
               Fields: {
                 ClientMessageID: this.$route.params.id
               }
             }]).then(r2=> {
               var cr2 = JSON.parse(r2.CommandResult);
               var tr = JSON.parse(cr2.returnObjects[0].returnObject);
               for (var x = 0; x < tr.length; x++) {
                 this.toAddresses+=this.buildSimUser(tr[x].ClientID, tr[x].Username, tr[x].EmailAddress, tr[x].FirstName, tr[x].LastName, false, false)+" ";
               }
               this.mess=tmess;
             });
           }
           else {
             this.setupInbox();
             this.mess=tmess;
           }
         });         

      });
    }
  }
</script>
